import React from "react";
import { Search, X } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const Field = ({ label, children }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">{label}</label>
    {children}
  </div>
);

export default function ListFilters({
  search, onSearch, placeholder = "Buscar...", searchTestId,
  from, to, onFrom, onTo,
  vendors, vendor, onVendor,
  statuses, status, onStatus, statusLabel = "Estado",
  extra, right, onClear,
}) {
  const active = !!(search || from || to || (vendor && vendor !== "all") || (status && status !== "all"));
  return (
    <div className="flex flex-col lg:flex-row lg:items-end gap-3 lg:justify-between">
      <div className="flex flex-wrap items-end gap-2">
        <div className="relative w-full sm:w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input data-testid={searchTestId} value={search} onChange={(e) => onSearch(e.target.value)} placeholder={placeholder} className="pl-9 rounded-sm" />
        </div>
        {onFrom && (
          <>
            <Field label="Desde"><Input type="date" data-testid="filter-from" value={from} onChange={(e) => onFrom(e.target.value)} className="rounded-sm w-[9.5rem]" /></Field>
            <Field label="Hasta"><Input type="date" data-testid="filter-to" value={to} onChange={(e) => onTo(e.target.value)} className="rounded-sm w-[9.5rem]" /></Field>
          </>
        )}
        {vendors && (
          <Field label="Vendedor">
            <Select value={vendor || "all"} onValueChange={onVendor}>
              <SelectTrigger className="rounded-sm w-44" data-testid="filter-vendor"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todos</SelectItem>
                {vendors.map((v) => <SelectItem key={v} value={v}>{v}</SelectItem>)}
              </SelectContent>
            </Select>
          </Field>
        )}
        {statuses && (
          <Field label={statusLabel}>
            <Select value={status || "all"} onValueChange={onStatus}>
              <SelectTrigger className="rounded-sm w-40" data-testid="filter-status"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todos</SelectItem>
                {statuses.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
              </SelectContent>
            </Select>
          </Field>
        )}
        {extra}
        {active && onClear && (
          <Button variant="ghost" className="rounded-sm gap-1 text-xs text-muted-foreground h-9" onClick={onClear} data-testid="filter-clear"><X className="h-3.5 w-3.5" /> Limpiar</Button>
        )}
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}
